module.exports = __webpack_public_path__ + "static/media/056-guinea-bissau.dba1fe55.svg";